import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { Icon } from '../Elements';

import classes from './InfoButton.module.scss';

const InfoButton = ({ className }) => {
  return (
    <button type="button" className={cn(classes.infoButton, className)}>
      <Icon icon={'Icn_Info'} className={classes.iconInfo} />
    </button>
  );
};

InfoButton.propTypes = {
  className: PropTypes.string
};

export default InfoButton;
